import React, { useEffect } from 'react';

import { UiDrawer } from '../../../../../common/UiDrawer';

interface PolicyEditDrawerProps {
    open: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
}

export const PolicyEditDrawer: React.FC<PolicyEditDrawerProps> = ({
    open,
    title,
    onClose,
    children,
}) => {
    // Hide the wizard's sticky footer while the drawer is open
    // to prevent it from clipping through the drawer overlay.
    useEffect(() => {
        if (!open) {
            return;
        }
        const stickyWrapper = document.querySelector<HTMLElement>(
            '.sticky-outer-wrapper',
        );
        if (stickyWrapper) {
            stickyWrapper.style.visibility = 'hidden';
        }
        return () => {
            if (stickyWrapper) {
                stickyWrapper.style.visibility = '';
            }
        };
    }, [ open ]);

    return (
        <UiDrawer
            title={title}
            drawerProps={{
                anchor: 'right',
                open,
                onClose,
            }}
            width="large"
            themeProps={{ disableGutters: true }}
        >
            {children}
        </UiDrawer>
    );
};
